export default "__VITE_ASSET__BMswSG62__"